/* @flow */
import { combineReducers } from 'redux';
import produtosMaisVendidosReducer from './produtos-mais-vendidos';
import cadastrosClientesReducer from './cadastros-clientes';

const relatoriosReducer = combineReducers({
    produtosMaisVendidos: produtosMaisVendidosReducer,
    cadastrosClientes: cadastrosClientesReducer,
});

export default relatoriosReducer;
